import React, { Fragment, useState, useEffect, useRef } from "react";
import { MenuItem, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  pathSpliter,
  checkAuthBranchWare,
  dateTimeFormat,
  checkIntNum,
  currentDateTime,
  getDateTimeFromISODT,
} from "../../lib/functions";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { APP_URL, API_URL } from "../../config";
import { useHistory } from "react-router-dom";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import * as XLSX from "xlsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import LoadingButton from "../commons/LoadingButton";
import PublishIcon from '@material-ui/icons/Publish';
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib

import "../sales/components/sale.css";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import swal from "sweetalert";
import { CardContent } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import commaNumber from "comma-number";

let format = commaNumber.bindWith(",", ".");

const EXCEL_FIELD_ALIASES = {
  brand: ["brand name", "brand", "product brand", "prod brand"],
  category: ["category", "product category", "prod category"],
  productName: ["product name", "product", "name", "item"],
  productCode: ["product code", "code", "prod code", "item code"],
  country: ["country origin", "country", "origin", "made in", "color", "colour"],
  floor: ["floor", "prod floor", "store floor"],
  rack: ["rack", "prod rack", "store rack", "bin"],
  quantity: ["quantity", "qty", "qnt", "qnty", "pcs"],
  purchaseRate: ["purchase rate", "purchase_rate", "rate", "buy rate", "buying rate", "cost", "unit cost"],
};

const normalizeExcelText = (value) => String(value ?? "").trim().toLowerCase();
const normalizeLooseExcelText = (value) =>
  normalizeExcelText(value)
    .normalize("NFKD")
    .replace(/[–—−]/g, "-")
    .replace(/[^a-z0-9]/g, "");
const normLoose = (value) => normalizeLooseExcelText(value);

const getExcelFieldValue = (row, aliases) => {
  const entry = Object.entries(row || {}).find(([key]) =>
    aliases.includes(normalizeExcelText(key))
  );
  return entry ? entry[1] : "";
};

const getProductDisplayName = (product) => String(product?.prod_name ?? "").trim();
const getProductBaseName = (product) => getProductDisplayName(product).split(" - ")[0] || "";
const appendWarning = (currentWarning, nextWarning) =>
  currentWarning ? `${currentWarning} ${nextWarning}` : nextWarning;
const isInvalidProductLabel = (value) => {
  const label = String(value ?? "").trim();
  return !label || /^[@0]+$/.test(label);
};
const getCartProductLabel = (item) => {
  const excelLabel = String(item?.prod_excel_name ?? "").trim();
  if (!isInvalidProductLabel(excelLabel)) return excelLabel;

  const baseLabel = String(item?.prod_name ?? "").split(" - ")[0].trim();
  if (!isInvalidProductLabel(baseLabel)) return baseLabel;

  const codeLabel = String(item?.prod_code ?? "").trim();
  if (!isInvalidProductLabel(codeLabel)) return codeLabel;

  return "";
};
const reorderSavedSummaryRows = (rows, recentProductIds = []) => {
  if (!Array.isArray(rows) || rows.length === 0) return rows || [];
  if (!Array.isArray(recentProductIds) || recentProductIds.length === 0) return rows;

  const pinnedIds = recentProductIds.map((id) => Number(id));

  return [...rows].sort((left, right) => {
    const leftIndex = pinnedIds.indexOf(Number(left?.prod_id));
    const rightIndex = pinnedIds.indexOf(Number(right?.prod_id));

    if (leftIndex === -1 && rightIndex === -1) return 0;
    if (leftIndex === -1) return 1;
    if (rightIndex === -1) return -1;

    return leftIndex - rightIndex;
  });
};
const getSavedSummaryMetaValue = (row, keys) => {
  const matchedKey = keys.find((key) => {
    const value = row?.[key];
    return value !== undefined && value !== null && String(value).trim() !== "";
  });

  return matchedKey ? row[matchedKey] : "-";
};
const getSavedSummaryQty = (row) => {
  return getSavedSummaryCurrentQty(row);
};
const getFirstNumericValue = (values, fallback = 0) => {
  for (const value of values) {
    const parsed = parseFloat(value);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return fallback;
};
const getSavedSummaryOpeningQty = (row) => {
  const candidates = [
    row?.opening_quantity,
    row?.os_qty,
    row?.prod_qty,
  ];
  return getFirstNumericValue(candidates, 0);
};
const getSavedSummaryCurrentQty = (row) => {
  const candidates = [
    row?.current_quantity,
    row?.current_stock,
    row?.prod_qty,
    row?.opening_quantity,
    row?.os_qty,
  ];
  return getFirstNumericValue(candidates, 0);
};
const OPENING_STOCK_SUMMARY_API = "/api/opening-stock-summary";
const getImportStatusMeta = (row) => {
  if (row?.isValid) {
    const successDetail = [row?.validationWarning, row?.autoCreateDetail]
      .filter(Boolean)
      .join(" ");
    if (row?.validationWarning) {
      return { label: "Matched", detail: successDetail, tone: "warning" };
    }
    return { label: "Ready", detail: row?.autoCreateDetail || "Row will be imported.", tone: "success" };
  }

  if (row?.validationError === "Missing in product list.") {
    return {
      label: "Missing Product",
      detail: row?.autoCreateDetail || "This product is not available in product list/database.",
      tone: "error",
    };
  }

  return {
    label: "Needs Review",
    detail: row?.validationError || "Please check this row.",
    tone: "error",
  };
};
const toSqlDateTime = (value) => {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) {
    const fallback = new Date();
    return fallback.toISOString().slice(0, 19).replace("T", " ");
  }
  return date.toISOString().slice(0, 19).replace("T", " ");
};
const sanitizePayloadDates = (value, keyName = "") => {
  if (Array.isArray(value)) {
    return value.map((item) => sanitizePayloadDates(item));
  }

  if (value && typeof value === "object") {
    return Object.entries(value).reduce((acc, [key, entryValue]) => {
      acc[key] = sanitizePayloadDates(entryValue, key);
      return acc;
    }, {});
  }

  if (
    typeof value === "string" &&
    /isodt$/i.test(keyName) &&
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)
  ) {
    return toSqlDateTime(value);
  }

  return value;
};

const OpeningStockEntry = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  const [selectedDate, handleDateChangeSet] = useState(currentDateTime());

  const history = useHistory();
  const fileInputRef = useRef(null);

  // States start
  // Initialize cart from localStorage
  let [cart, cartSet] = useState(() => {
    const savedCart = localStorage.getItem('salesCart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  let [storageCart, storageCartSet] = useState(() => {
    const savedStorageCart = localStorage.getItem('salesStorageCart');
    return savedStorageCart ? JSON.parse(savedStorageCart) : [];
  });

  let [employees, employeesSet] = useState([]);
  let [customers, customersSet] = useState([]);
  let [floors, floorsSet] = useState([]);
  let [racks, racksSet] = useState([]);
  let [contactPersons, contactPersonsSet] = useState([]);
  let [products, productsSet] = useState([]);
  let [brands, brandsSet] = useState([])
  let [countrys, countrysSet] = useState([])
  let [categories, categoriesSet] = useState([])

  // --- Excel Import States ---
  const [excelData, setExcelData] = useState([]);
  const [isExcelUploadDialogOpen, setExcelUploadDialogOpen] = useState(false);
  const [importSourceRows, setImportSourceRows] = useState([]);
  const [isImportProcessing, setImportProcessing] = useState(false);
  const [, setImportDebugMap] = useState({});
  const [prodNames, prodNamesSet] = useState([]);
  const [units, unitsSet] = useState([]);

  const [floor, setFloor] = useState({ prod_floor_id: 0, prod_floor_name: "" });
  const [rack, setRack] = useState({ prod_rack_id: 0, prod_rack_name: "" });

  let [selectedEmployee, selectedEmployeeSet] = useState(null);
  let [selectedCustomer, selectedCustomerSet] = useState(null);
  let [selectedContactPerson, selectedContactPersonSet] = useState(null);
  let [selectedFloor, selectedFloorSet] = useState(null);
  let [selectedQuantity, selectedQuantitySet] = useState(null);
  let [selectedRack, selectedRackSet] = useState(null);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [selectedId, selectedIdSet] = useState(null);

  const [editCartIndex, setEditCartIndex] = useState(null);
  const [inlineQtyEditIndex, setInlineQtyEditIndex] = useState(null);
  const [inlineQtyValue, setInlineQtyValue] = useState("");

  let [saveAction, saveActionSet] = useState(false);

  let [customerPayAccs, customerPayAccsSet] = useState([]);
  let [customer_type, customer_type_set] = useState("retail");

  let [selectedCustomerPayMethod, selectedCustomerPayMethodSet] = useState(
    { pay_method_id: "cash", pay_method: "Cash" }
  );
  let [selectedCustomerPayAcc, selectedCustomerPayAccSet] = useState(null);

  let [sale_invoice, sale_invoice_set] = useState("");
  let [po_id, po_id_set] = useState("");
  let [sale_emp_id, sale_emp_id_set] = useState(0);

  let [sale_created_isodt, sale_created_isodt_set] = useState("");

  let [customer_name, customer_name_set] = useState("");
  let [customer_mobile_no, customer_mobile_no_set] = useState("");
  let [customer_address, customer_address_set] = useState("");

  let [product_rate, product_rate_set] = useState(0);
  let [product_brand, product_brand_set] = useState("");
  let [product_floor, product_floor_set] = useState("");
  let [product_rack, product_rack_set] = useState("");
  let [product_color, product_color_set] = useState("");
  let [product_qty, product_qty_set] = useState("0");
  let [product_total, product_total_set] = useState(0);

  let [product_stock_status, product_stock_status_set] = useState("stock status");
  let [product_stock_qty, product_stock_qty_set] = useState("stock qty");
  let [product_unit, product_unit_set] = useState("unit");
  let [product_purchase_rate, product_purchase_rate_set] =
    useState("purchase rate");

  let [general_customer, general_customer_set] = useState(false);

  let [note, note_set] = useState("");
  let [sub_total, sub_total_set] = useState(0);
  let [previous_due, previous_due_set] = useState(0);
  let [vat, vat_set] = useState(0);
  let [ait, ait_set] = useState(0);
  let [vat_percent, vat_percent_set] = useState(0);
  let [ait_percent, ait_percent_set] = useState(0);
  let [discount, discount_set] = useState(0);
  let [discount_percent, discount_percent_set] = useState(0);
  let [total_amount, total_amount_set] = useState(0);
  let [paid, paid_set] = useState(0);
  let [due, due_set] = useState(0);
  let [transport_cost, transport_cost_set] = useState(0);
  let [saleAction, saleActionSet] = useState("create");
  let [saleId, saleIdSet] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState("");
  let customerPayMethods = [
    { pay_method_id: "cash", pay_method: "cash" },
    { pay_method_id: "bank", pay_method: "bank" },
  ];
  const [resetKey, setResetKey] = useState(0);
  const [savedSummaryRows, setSavedSummaryRows] = useState([]);
  const [savedSummaryLoading, setSavedSummaryLoading] = useState(false);
  const [savedSummaryUpdating, setSavedSummaryUpdating] = useState(false);
  const [savedSummarySearchText, setSavedSummarySearchText] = useState("");
  const [savedSummaryEditRowKey, setSavedSummaryEditRowKey] = useState("");
  const [savedSummaryEditPurchaseRate, setSavedSummaryEditPurchaseRate] = useState("");
  const [savedSummaryEditQuantity, setSavedSummaryEditQuantity] = useState("");
  const [savedSummaryEditCurrentQuantity, setSavedSummaryEditCurrentQuantity] = useState("");
  const [savedSummaryEditOriginalQuantity, setSavedSummaryEditOriginalQuantity] = useState(0);
  const [savedSummaryEditOriginalCurrentQuantity, setSavedSummaryEditOriginalCurrentQuantity] = useState(0);
  const [savedSummaryPagination, setSavedSummaryPagination] = useState({
    page: 0,
    perPage: 10,
    total: 0,
  });
  const [recentSavedProductIds, setRecentSavedProductIds] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("openingStockRecentProductIds") || "[]");
      return Array.isArray(saved) ? saved : [];
    } catch (_err) {
      return [];
    }
  });
  // State End
  const [locations, setLocations] = useState(
    {
      prod_floor_name: "",
      prod_rack_name: "",
    } || []
  );
  const [floorData, setFloorData] = useState([]);

  const fetchSavedSummary = async (
    recentProductIds = recentSavedProductIds,
    pageOverride = savedSummaryPagination.page,
    perPageOverride = savedSummaryPagination.perPage,
    searchOverride = savedSummarySearchText
  ) => {
    setSavedSummaryLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}${OPENING_STOCK_SUMMARY_API}`,
        {
          action: "list",
          search: String(searchOverride || "").trim(),
          page: Number(pageOverride || 0) + 1,
          perPage: Number(perPageOverride || 10),
          recentProductIds,
        },
        { headers: { "auth-token": authInfo.token } }
      );

      const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
      const pagination = response?.data?.pagination || {};

      const normalizedRows = rows.map((row, index) => {
        const openingQty = getSavedSummaryOpeningQty(row);
        const currentQty = getSavedSummaryCurrentQty(row);
        const rate = parseFloat(row?.prod_purchase_rate || 0);
        const rowId = row?.row_id || row?.os_d_id || row?.detail_id || `${row?.prod_id || "product"}-${index}`;
        return {
          ...row,
          opening_quantity: openingQty,
          current_stock: currentQty,
          current_quantity: currentQty,
          prod_qty: currentQty,
          prod_total: currentQty * rate,
          stock_value: currentQty * rate,
          __rowKey: String(rowId),
        };
      });

      setSavedSummaryRows(reorderSavedSummaryRows(normalizedRows, recentProductIds));
      setSavedSummaryPagination({
        page: Math.max((Number(pagination.page) || (Number(pageOverride || 0) + 1)) - 1, 0),
        perPage: Number(pagination.perPage) || Number(perPageOverride || 10),
        total: Number(pagination.total) || normalizedRows.length,
      });
    } catch (err) {
      swal({
        title: "Saved stock summary load failed",
        text:
          err?.response?.data?.message ||
          `Backend ready হলে ${OPENING_STOCK_SUMMARY_API} endpoint-এ list action return করবে.`,
        icon: "error",
      });
    } finally {
      setSavedSummaryLoading(false);
    }
  };

  const startSavedSummaryEdit = (row) => {
    setSavedSummaryEditRowKey(row?.__rowKey || "");
    setSavedSummaryEditPurchaseRate(String(parseFloat(row?.prod_purchase_rate || 0)));
    const openingQty = getSavedSummaryOpeningQty(row);
    const currentQty = getSavedSummaryQty(row);
    setSavedSummaryEditQuantity(String(openingQty));
    setSavedSummaryEditCurrentQuantity(String(currentQty));
    setSavedSummaryEditOriginalQuantity(openingQty);
    setSavedSummaryEditOriginalCurrentQuantity(currentQty);
  };

  const cancelSavedSummaryEdit = () => {
    setSavedSummaryEditRowKey("");
    setSavedSummaryEditPurchaseRate("");
    setSavedSummaryEditQuantity("");
    setSavedSummaryEditCurrentQuantity("");
    setSavedSummaryEditOriginalQuantity(0);
    setSavedSummaryEditOriginalCurrentQuantity(0);
  };

  const handleCurrentQuantityChange = (val) => {
    setSavedSummaryEditCurrentQuantity(val);
    const nextCurrentQty = parseFloat(val);
    if (!Number.isNaN(nextCurrentQty)) {
      const delta = nextCurrentQty - savedSummaryEditOriginalCurrentQuantity;
      const nextOpeningQty = savedSummaryEditOriginalQuantity + delta;
      setSavedSummaryEditQuantity(String(nextOpeningQty));
    }
  };

  const handleOpeningQuantityChange = (val) => {
    setSavedSummaryEditQuantity(val);
    const nextOpeningQty = parseFloat(val);
    if (!Number.isNaN(nextOpeningQty)) {
      const delta = nextOpeningQty - savedSummaryEditOriginalQuantity;
      const nextCurrentQty = savedSummaryEditOriginalCurrentQuantity + delta;
      setSavedSummaryEditCurrentQuantity(String(nextCurrentQty));
    }
  };

  const saveSavedSummaryEdit = async () => {
    const nextQty = parseFloat(savedSummaryEditQuantity);
    const nextRate = parseFloat(savedSummaryEditPurchaseRate);

    if (Number.isNaN(nextQty) || nextQty < 0) {
      swal({ title: "Invalid quantity", icon: "warning" });
      return;
    }

    if (Number.isNaN(nextRate) || nextRate < 0) {
      swal({ title: "Invalid purchase rate", icon: "warning" });
      return;
    }

    try {
      setSavedSummaryUpdating(true);

      const editingRow = savedSummaryRows.find((row) => row.__rowKey === savedSummaryEditRowKey);
      if (!editingRow) {
        swal({ title: "Editable row not found", icon: "warning" });
        return;
      }

      const response = await axios.post(
        `${API_URL}${OPENING_STOCK_SUMMARY_API}`,
        {
          action: "update",
          rowId: editingRow?.row_id || editingRow?.os_d_id || editingRow?.detail_id || editingRow?.__rowKey,
          productId: editingRow?.prod_id,
          openingQuantity: nextQty,
          purchaseRate: nextRate,
        },
        { headers: { "auth-token": authInfo.token } }
      );

      if (response?.data?.error) {
        swal({
          title: "Update failed",
          text: response?.data?.message || "Could not update opening stock summary item.",
          icon: "error",
        });
        return;
      }

      cancelSavedSummaryEdit();
      await fetchSavedSummary(
        recentSavedProductIds,
        savedSummaryPagination.page,
        savedSummaryPagination.perPage,
        savedSummarySearchText
      );

      swal({
        title: "Updated successfully",
        text: response?.data?.message || "Saved stock summary item updated successfully.",
        icon: "success",
      });
    } catch (err) {
      swal({
        title: "Update failed",
        text:
          err?.response?.data?.message ||
          `Backend ready হলে ${OPENING_STOCK_SUMMARY_API} endpoint-এ update action handle করবে.`,
        icon: "error",
      });
    } finally {
      setSavedSummaryUpdating(false);
    }
  };

  // Persist cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('salesCart', JSON.stringify(cart));
    localStorage.setItem('salesStorageCart', JSON.stringify(storageCart));
  }, [cart, storageCart]);

  // Cleanup localStorage on component unmount
  useEffect(() => {
    return () => {
      // Only clear if sale wasn't completed
      if (!saveAction) {
        localStorage.removeItem('salesCart');
        localStorage.removeItem('salesStorageCart');
      }
    };
  }, [saveAction]);

  useEffect(() => {
    localStorage.setItem("openingStockRecentProductIds", JSON.stringify(recentSavedProductIds));
  }, [recentSavedProductIds]);

  useEffect(() => {
    selectedCustomerSet(null);
    customer_name_set("");
    customer_address_set("");
    customer_mobile_no_set("");
    selectedProductSet(null);
    product_rate_set("");
    product_brand_set("");
    product_color_set("");

    let prods = products.map((prod) => {
      if (customer_type == "wholesale") {
        prod.prod_rate = prod.prod_whole_sale_rate;
      }
      if (customer_type == "retail") {
        prod.prod_rate = prod.prod_sale_rate;
      }
      return prod;
    });

    productsSet(prods);
  }, [customer_type]);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    fetchFloors()
    fetchRacks()
    getEmployees();
    getCategories();
    getBrands();
    getColors();
    getProdNames();
    getUnits();
    getProducts();

    if (pathSpliter(location.pathname, 3) != undefined) {
      saleActionSet("update");
      saleIdSet(parseFloat(pathSpliter(location.pathname, 3)));
      getEntry();
    }

    fetchSavedSummary(recentSavedProductIds, 0, savedSummaryPagination.perPage, "");
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSavedSummary(
        recentSavedProductIds,
        savedSummaryPagination.page,
        savedSummaryPagination.perPage,
        savedSummarySearchText
      );
    }, 350);

    return () => clearTimeout(timer);
  }, [savedSummaryPagination.page, savedSummaryPagination.perPage, savedSummarySearchText]);

  let getEntry = async () => {
    // Previous getEntry logic remains unchanged
  };

  // --- Start of Excel Import Logic ---

  const handleExcelFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const bstr = event.target.result;
      const wb = XLSX.read(bstr, { type: "binary", cellText: true, raw: false });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const rawData = XLSX.utils.sheet_to_json(ws, { defval: "", raw: false, blankrows: false });

      try {
        setImportProcessing(true);
        setImportSourceRows(rawData);
        setImportDebugMap({});

        const getRowValue = (row, field) => getExcelFieldValue(row, EXCEL_FIELD_ALIASES[field] || [field]);

        const mappedRows = rawData.map((row) => ({
          floor: String(getRowValue(row, "floor") || "").trim(),
          rack: String(getRowValue(row, "rack") || "").trim(),
          category: String(getRowValue(row, "category") || "").trim(),
          brand: String(getRowValue(row, "brand") || "").trim(),
          productName: String(getRowValue(row, "productName") || "").trim(),
          country: String(getRowValue(row, "country") || "").trim(),
          unit: String(getRowValue(row, "unit") || "").trim(),
          quantity: String(getRowValue(row, "quantity") || "").trim(),
          purchaseRate: String(getRowValue(row, "purchaseRate") || "").trim(),
        }));

        const response = await axios.post(
          `${API_URL}/api/resolve-opening-stock-import`,
          { rows: mappedRows },
          { headers: { "auth-token": authInfo.token } }
        );

        if (response?.data?.error) {
          throw new Error(response.data.message || "Import resolve failed.");
        }

        const backendRows = Array.isArray(response?.data?.rows) ? response.data.rows : [];

        const previewRows = backendRows.map((result, idx) => {
          const originalMapped = mappedRows[result.rowIndex ?? idx] || mappedRows[idx] || {};
          if (result.status === "ready" && result.cartItem) {
            const ci = result.cartItem;
            return {
              'Brand': ci.prod_brand_name,
              'Category': ci.prod_cat_name,
              'Product Name': ci.prod_name,
              'Country Origin': ci.prod_color_name,
              'Floor': ci.prod_floor_name,
              'Rack': ci.prod_rack_name,
              'Quantity': ci.prod_qty,
              'Purchase Rate': ci.prod_purchase_rate,
              isValid: true,
              validationError: '',
              validationWarning: '',
              autoCreateDetail: result.message || "Ready",
              _resolvedCartItem: ci,
            };
          }
          return {
            'Brand': originalMapped.brand || '',
            'Category': originalMapped.category || '',
            'Product Name': originalMapped.productName || '',
            'Country Origin': originalMapped.country || '',
            'Floor': originalMapped.floor || '',
            'Rack': originalMapped.rack || '',
            'Quantity': originalMapped.quantity || '',
            'Purchase Rate': originalMapped.purchaseRate || '',
            isValid: false,
            validationError: result.message || "Could not resolve row.",
            validationWarning: '',
            autoCreateDetail: result.message || "Error",
            _resolvedCartItem: null,
          };
        });

        setExcelData(previewRows);
        setExcelUploadDialogOpen(true);

        const { ready = 0, errors = 0 } = response.data.summary || {};
        if (ready > 0 && errors === 0) {
          swal({
            title: `${ready} row(s) ready to import`,
            icon: "success",
            timer: 1500,
            buttons: false,
          });
        } else if (ready > 0 && errors > 0) {
          swal({
            title: `${ready} row(s) ready, ${errors} need review`,
            icon: "warning",
            timer: 2000,
            buttons: false,
          });
        } else if (errors > 0) {
          swal({
            title: "Some rows could not be resolved",
            text: "Please check the status column in the import review popup.",
            icon: "warning",
            timer: 2200,
            buttons: false,
          });
        }
      } catch (error) {
        swal({
          title: "Import preparation failed",
          text: error.response?.data?.message || error.message,
          icon: "error",
        });
      } finally {
        setImportProcessing(false);
      }
    };
    reader.readAsBinaryString(file);

    e.target.value = null;
  };

  // --- inside your existing validateAndSetExcelData function ---
  const validateAndSetExcelData = (excelRows, overrides = {}) => {
    const norm = (value) => normalizeExcelText(value);
    const normLoose = (value) => normalizeLooseExcelText(value);
    const productList = overrides.products || products || [];
    const floorList = overrides.floors || floors || [];
    const rackList = overrides.racks || racks || [];
    const numberToken = (value) => {
      const m = String(value || "").match(/\d+/);
      return m ? m[0] : "";
    };
    const toPositiveNumber = (value) =>
      parseFloat(String(value ?? "").replace(/,/g, "").trim());

    const getRowValue = (row, field) =>
      getExcelFieldValue(row, EXCEL_FIELD_ALIASES[field] || [field]);

    const validatedData = excelRows.map(row => {
      const brandName = String(getRowValue(row, "brand") || "").trim();
      const categoryName = String(getRowValue(row, "category") || "").trim();
      const productName = String(getRowValue(row, "productName") || "").trim();
      const productCode = String(getRowValue(row, "productCode") || "").trim();
      const countryName = String(getRowValue(row, "country") || "").trim(); // matches prod_color_name
      const floorName = String(getRowValue(row, "floor") || "").trim();
      const rackName = String(getRowValue(row, "rack") || "").trim();
      const quantity = toPositiveNumber(getRowValue(row, "quantity"));
      const purchaseRate = toPositiveNumber(getRowValue(row, "purchaseRate"));

      const validationResult = {
        'Brand': brandName,
        'Category': categoryName,
        'Product Name': productName,
        'Country Origin': countryName,
        'Floor': floorName,
        'Rack': rackName,
        'Quantity': quantity,
        'Purchase Rate': purchaseRate,

        isValid: false,
        validationError: '',
        validationWarning: '',
        matchedProduct: null,
        matchedFloor: null,
        matchedRack: null,
      };

      if (!brandName || !categoryName || !productName || !countryName || !floorName || !rackName) {
        validationResult.validationError = "Missing one or more required Excel fields.";
        return validationResult;
      }

      // 1. Product matching (strict enough to avoid wrong auto-mapping)
      const byCode = productCode
        ? productList.find((p) => normLoose(p.prod_code) === normLoose(productCode))
        : null;

      const productBase = norm(productName);
      const productBaseLoose = normLoose(productName);
      const validProducts = productList.filter((p) => getProductDisplayName(p));
      const productCandidates = validProducts.filter((p) => {
        const displayName = getProductDisplayName(p);
        const baseName = getProductBaseName(p);
        const pName = norm(displayName);
        const pBase = norm(baseName);
        const pLoose = normLoose(displayName);
        const pBaseLoose = normLoose(baseName);
        return (
          (productBase && (pBase === productBase || pName === productBase)) ||
          (productBaseLoose &&
            (pBaseLoose === productBaseLoose ||
              pLoose === productBaseLoose))
        );
      });

      const productSearchToken = numberToken(productName);
      const exactNameCandidates = validProducts.filter((p) => {
        const displayName = getProductDisplayName(p);
        const baseName = getProductBaseName(p);
        return normLoose(displayName) === productBaseLoose || normLoose(baseName) === productBaseLoose;
      });
      const tokenOnlyCandidates = validProducts.filter((p) => {
        const candidateToken = numberToken(getProductDisplayName(p)) || numberToken(getProductBaseName(p)) || numberToken(p.prod_code);
        return productSearchToken && candidateToken && candidateToken === productSearchToken;
      });
      const scoredCandidates = validProducts
        .map((p) => {
          const displayName = getProductDisplayName(p);
          const baseName = getProductBaseName(p);
          const looseDisplay = normLoose(displayName);
          const looseBase = normLoose(baseName);
          const looseCode = normLoose(p.prod_code);
          const looseBrand = normLoose(p.prod_brand_name);
          const looseCategory = normLoose(p.prod_cat_name);
          const looseCountry = normLoose(p.prod_color_name);
          const candidateToken = numberToken(displayName) || numberToken(baseName) || numberToken(p.prod_code);

          let score = 0;
          if (productCode && looseCode && looseCode === normLoose(productCode)) score += 1000;
          if (productBaseLoose && looseBase === productBaseLoose) score += 700;
          if (productBaseLoose && looseDisplay === productBaseLoose) score += 650;
          if (productSearchToken && candidateToken && productSearchToken === candidateToken) score += 350;
          if (brandName && looseBrand === normLoose(brandName)) score += 120;
          else if (brandName && looseBrand.includes(normLoose(brandName))) score += 70;
          if (categoryName && looseCategory === normLoose(categoryName)) score += 110;
          else if (categoryName && looseCategory.includes(normLoose(categoryName))) score += 60;
          if (countryName && looseCountry === normLoose(countryName)) score += 100;
          else if (countryName && looseCountry.includes(normLoose(countryName))) score += 50;

          return { product: p, score };
        })
        .filter(({ score }) => score > 0)
        .sort((left, right) => right.score - left.score);

      const bestScoredCandidate = scoredCandidates[0];
      const secondBestScore = scoredCandidates[1]?.score ?? -1;
      const uniqueExactNameProduct = exactNameCandidates.length === 1 ? exactNameCandidates[0] : null;
      const uniqueTokenProduct = tokenOnlyCandidates.length === 1 ? tokenOnlyCandidates[0] : null;
      const exactAttributeCandidate =
        productCandidates.length > 0
          ? productCandidates.find((p) => {
              const brandOk = !brandName || normLoose(p.prod_brand_name) === normLoose(brandName);
              const categoryOk = !categoryName || normLoose(p.prod_cat_name) === normLoose(categoryName);
              const countryOk = !countryName || normLoose(p.prod_color_name) === normLoose(countryName);
              return brandOk && categoryOk && countryOk;
            }) || null
          : null;
      const highConfidenceScoredProduct =
        bestScoredCandidate &&
        bestScoredCandidate.score >= 850 &&
        bestScoredCandidate.score - secondBestScore >= 150
          ? bestScoredCandidate.product
          : null;
      const product =
        byCode ||
        exactAttributeCandidate ||
        uniqueExactNameProduct ||
        (productCode ? uniqueTokenProduct : null) ||
        highConfidenceScoredProduct;

      if (!product) {
        validationResult.validationError = "Missing in product list.";
        return validationResult;
      }
      validationResult.matchedProduct = product;

      if (brandName && normLoose(product.prod_brand_name) !== normLoose(brandName)) {
        validationResult.validationWarning = appendWarning(
          validationResult.validationWarning,
          `Brand "${brandName}" matched with "${product.prod_brand_name}".`
        );
      }
      if (categoryName && normLoose(product.prod_cat_name) !== normLoose(categoryName)) {
        validationResult.validationWarning = appendWarning(
          validationResult.validationWarning,
          `Category "${categoryName}" matched with "${product.prod_cat_name}".`
        );
      }
      if (countryName && normLoose(product.prod_color_name) !== normLoose(countryName)) {
        validationResult.validationWarning = appendWarning(
          validationResult.validationWarning,
          `Country "${countryName}" matched with "${product.prod_color_name}".`
        );
      }
      if ((uniqueExactNameProduct || uniqueTokenProduct) && !validationResult.validationWarning) {
        validationResult.validationWarning = "Matched by product name only.";
      }

      // 2. Validate Floor and Rack combination
      let potentialFloors = floorList.filter((f) => {
        const exact = normLoose(f.prod_floor_name) === normLoose(floorName);
        const contains =
          normLoose(f.prod_floor_name).includes(normLoose(floorName)) ||
          normLoose(floorName).includes(normLoose(f.prod_floor_name));
        const numberMatch =
          numberToken(f.prod_floor_name) &&
          numberToken(floorName) &&
          numberToken(f.prod_floor_name) === numberToken(floorName);
        return exact || contains || numberMatch;
      });

      if (potentialFloors.length === 0 && floorList.length > 0) {
        potentialFloors = [floorList[0]];
        validationResult.validationWarning = `Floor "${floorName}" not found. Auto-selected "${floorList[0].prod_floor_name}".`;
      }
      if (potentialFloors.length === 0) {
        validationResult.validationError = "Floor not found.";
        return validationResult;
      }

      let validRackFound = false;
      for (const potentialFloor of potentialFloors) {
        const rack = rackList.find(r =>
          (
            normLoose(r.prod_rack_name) === normLoose(rackName) ||
            normLoose(r.prod_rack_name).includes(normLoose(rackName)) ||
            normLoose(rackName).includes(normLoose(r.prod_rack_name)) ||
            (numberToken(r.prod_rack_name) &&
              numberToken(rackName) &&
              numberToken(r.prod_rack_name) === numberToken(rackName))
          ) &&
          r.prod_floor_id === potentialFloor.prod_floor_id
        );

        if (rack) {
          validationResult.matchedFloor = potentialFloor;
          validationResult.matchedRack = rack;
          validRackFound = true;
          break;
        }
      }

      if (!validRackFound) {
        const fallbackRack =
          rackList.find((r) => r.prod_floor_id === potentialFloors[0].prod_floor_id) ||
          rackList[0];
        if (fallbackRack) {
          validationResult.matchedFloor = potentialFloors[0];
          validationResult.matchedRack = fallbackRack;
          validRackFound = true;
          validationResult.validationWarning = validationResult.validationWarning
            ? `${validationResult.validationWarning} Rack "${rackName}" not found. Auto-selected "${fallbackRack.prod_rack_name}".`
            : `Rack "${rackName}" not found. Auto-selected "${fallbackRack.prod_rack_name}".`;
        }
      }
      if (!validRackFound) {
        validationResult.validationError = `Rack "${rackName}" not found in Floor "${floorName}".`;
        return validationResult;
      }

      // 3. Validate Quantity and Rate
      if (isNaN(quantity) || quantity <= 0) {
        validationResult.validationError = "Invalid quantity.";
        return validationResult;
      }
      if (isNaN(purchaseRate) || purchaseRate <= 0) {
        validationResult.validationError = "Invalid purchase rate.";
        return validationResult;
      }

      // Passed all checks
      validationResult.isValid = true;
      return validationResult;
    });

    setExcelData(validatedData);
    setExcelUploadDialogOpen(true);
    return validatedData;
  };

  const getImportRowKey = (row) => [
    normLoose(row?.Brand),
    normLoose(row?.Category),
    normLoose(row?.["Product Name"]),
    normLoose(row?.["Country Origin"]),
    normLoose(row?.Floor),
    normLoose(row?.Rack),
  ].join("|");

  const annotateImportRows = (rows, debugEntries = {}) =>
    (rows || []).map((row) => {
      const debugInfo = debugEntries[getImportRowKey(row)];
      if (!debugInfo) return row;

      return {
        ...row,
        autoCreateStatus: debugInfo.status,
        autoCreateDetail: debugInfo.detail,
      };
    });


  const handleCloseExcelDialog = () => {
    setExcelUploadDialogOpen(false);
    setExcelData([]);
    setImportSourceRows([]);
    setImportDebugMap({});
  };

  const findByNameLoose = (items, key, value) =>
    (items || []).find((item) => normLoose(item?.[key]) === normLoose(value));

  const ensureNamedMaster = async ({ value, list, key, createUrl, payloadKey, refreshList, setter }) => {
    if (!String(value || "").trim()) return null;

    const existing = findByNameLoose(list, key, value);
    if (existing) return { item: existing, list };

    const response = await axios.post(
      `${API_URL}${createUrl}`,
      { [payloadKey]: String(value).trim(), action: "create" },
      { headers: { "auth-token": authInfo.token } }
    );
    if (response?.data?.error) {
      throw new Error(response.data.message || `Failed to create ${String(value).trim()}.`);
    }
    if (response?.data?.warning) {
      throw new Error(response.data.message || `Could not safely create ${String(value).trim()}.`);
    }

    const refreshed = await refreshList();
    if (setter) setter(refreshed);
    const createdItem = findByNameLoose(refreshed, key, value);
    if (!createdItem) {
      throw new Error(`${String(value).trim()} was not found after refresh.`);
    }
    return { item: createdItem, list: refreshed };
  };

  const getDefaultUnit = () => {
    const preferredUnit =
      findByNameLoose(units, "prod_unit_name", "pcs") ||
      findByNameLoose(units, "prod_unit_name", "piece") ||
      findByNameLoose(units, "prod_unit_name", "nos");
    return preferredUnit || units[0] || null;
  };

  const autoCreateMissingProducts = async (rowsToCreate) => {
    const results = [];
    let categoryList = [...categories];
    let brandList = [...brands];
    let colorList = [...countrys];
    let prodNameList = [...prodNames];
    let unitList = [...units];

    if (unitList.length === 0) {
      unitList = await getUnits();
    }

    for (const row of rowsToCreate) {
      const brandName = String(row?.Brand || "").trim();
      const categoryName = String(row?.Category || "").trim();
      const productName = String(row?.["Product Name"] || "").trim();
      const countryName = String(row?.["Country Origin"] || "").trim();
      const rowKey = getImportRowKey(row);
      if (!brandName || !categoryName || !productName || !countryName) {
        results.push({
          key: rowKey,
          status: "failed",
          detail: "Auto-create skipped because one or more required fields are missing.",
        });
        continue;
      }

      const existingProduct = (products || []).find((product) =>
        normLoose(product?.prod_name) === normLoose(productName) &&
        normLoose(product?.prod_brand_name) === normLoose(brandName) &&
        normLoose(product?.prod_cat_name) === normLoose(categoryName) &&
        normLoose(product?.prod_color_name) === normLoose(countryName)
      );
      if (existingProduct) {
        results.push({
          key: rowKey,
          status: "exists",
          detail: `Product already exists as "${existingProduct.prod_name}".`,
        });
        continue;
      }

      try {
        const categoryResult = await ensureNamedMaster({
          value: categoryName,
          list: categoryList,
          key: "prod_cat_name",
          createUrl: "/api/category-cu",
          payloadKey: "prod_cat_name",
          refreshList: getCategories,
          setter: categoriesSet,
        });
        categoryList = categoryResult?.list || categoryList;
        const category = categoryResult?.item;

        const brandResult = await ensureNamedMaster({
          value: brandName,
          list: brandList,
          key: "prod_brand_name",
          createUrl: "/api/brand-cu",
          payloadKey: "prod_brand_name",
          refreshList: getBrands,
          setter: brandsSet,
        });
        brandList = brandResult?.list || brandList;
        const brand = brandResult?.item;

        const colorResult = await ensureNamedMaster({
          value: countryName,
          list: colorList,
          key: "prod_color_name",
          createUrl: "/api/color-cu",
          payloadKey: "prod_color_name",
          refreshList: getColors,
          setter: countrysSet,
        });
        colorList = colorResult?.list || colorList;
        const color = colorResult?.item;

        const prodNameResult = await ensureNamedMaster({
          value: productName,
          list: prodNameList,
          key: "prod_name",
          createUrl: "/api/prod-name-cu",
          payloadKey: "prod_name",
          refreshList: getProdNames,
          setter: prodNamesSet,
        });
        prodNameList = prodNameResult?.list || prodNameList;
        const prodName = prodNameResult?.item;

        const preferredUnit =
          findByNameLoose(unitList, "prod_unit_name", "pcs") ||
          findByNameLoose(unitList, "prod_unit_name", "piece") ||
          findByNameLoose(unitList, "prod_unit_name", "nos");
        const unit = preferredUnit || unitList[0] || null;

        if (!category || !brand || !color || !prodName || !unit) {
          throw new Error(`Could not resolve all master data for ${productName}.`);
        }

        const nextCode = await getNextProductCode();
        const productCreateResponse = await axios.post(
          `${API_URL}/api/product-cu`,
          {
            prod_id: 0,
            prod_code: nextCode,
            productUpdateIndex: 0,
            prod_cat_id: category.prod_cat_id,
            prod_brand_id: brand.prod_brand_id,
            prod_color_id: color.prod_color_id,
            prod_name_id: prodName.prod_name_id,
            prod_unit_id: unit.prod_unit_id || null,
            prod_unit_name: unit.prod_unit_name,
            prod_is_service: "false",
            action: "create",
            prod_re_order_lebel: 0,
          },
          { headers: { "auth-token": authInfo.token } }
        );
        if (productCreateResponse?.data?.error) {
          throw new Error(productCreateResponse.data.message || `Could not create ${productName}.`);
        }
        if (productCreateResponse?.data?.warning) {
          throw new Error(productCreateResponse.data.message || `Product creation warning for ${productName}.`);
        }

        results.push({
          key: rowKey,
          status: "created",
          detail: `Created product "${productName}" in product list.`,
        });
      } catch (error) {
        results.push({
          key: rowKey,
          status: "failed",
          detail: `Auto-create failed for "${productName}". ${error.response?.data?.message || error.message}`,
        });
      }
    }

    if (results.some((entry) => entry.status === "created")) {
      await getProducts();
    }

    return results;
  };

  const handleConfirmExcelImport = async () => {
    try {
      setImportProcessing(true);

      const reviewRows = [...excelData];
      const rowsForCart = reviewRows.filter((row) => row.isValid);
      const importedRowsCount = rowsForCart.length;

      if (importedRowsCount === 0) {
        swal({
          title: "No valid rows to add",
          text: "Please review rows marked in red.",
          icon: "warning",
        });
        return;
      }

      const mergedCart = [...cart];

      rowsForCart.forEach((row) => {
        if (row._resolvedCartItem) {
          const ci = row._resolvedCartItem;
          const existingIndex = mergedCart.findIndex(
            (item) =>
              item.prod_id === ci.prod_id &&
              Number(item.prod_floor) === Number(ci.prod_floor) &&
              Number(item.prod_rack) === Number(ci.prod_rack) &&
              Number(item.prod_purchase_rate) === Number(ci.prod_purchase_rate)
          );
          if (existingIndex > -1) {
            const existing = mergedCart[existingIndex];
            const nextQty = parseFloat(existing.prod_qty || 0) + parseFloat(ci.prod_qty || 0);
            mergedCart[existingIndex] = {
              ...existing,
              prod_qty: nextQty,
              prod_total: nextQty * parseFloat(ci.prod_purchase_rate || 0),
            };
          } else {
            mergedCart.push({
              prod_id: ci.prod_id,
              prod_name: ci.prod_name,
              prod_excel_name: ci.prod_name,
              prod_code: ci.prod_code,
              prod_purchase_rate: ci.prod_purchase_rate,
              prod_brand: ci.prod_brand_name,
              prod_color: ci.prod_color_name,
              prod_floor: ci.prod_floor,
              prod_floor_name: ci.prod_floor_name,
              prod_rack: ci.prod_rack,
              prod_rack_name: ci.prod_rack_name,
              prod_qty: ci.prod_qty,
              prod_total: ci.prod_total,
            });
          }
          return;
        }

        // Fallback: use locally matched data (existing rows that were already valid before backend resolve)
        if (row.matchedProduct && row.matchedFloor && row.matchedRack) {
          const existingIndex = mergedCart.findIndex(
            (item) =>
              item.prod_id === row.matchedProduct.prod_id &&
              Number(item.prod_floor) === Number(row.matchedFloor.prod_floor_id) &&
              Number(item.prod_rack) === Number(row.matchedRack.prod_rack_id) &&
              Number(item.prod_purchase_rate) === Number(row['Purchase Rate'])
          );
          if (existingIndex > -1) {
            const existing = mergedCart[existingIndex];
            const nextQty = parseFloat(existing.prod_qty || 0) + parseFloat(row['Quantity'] || 0);
            mergedCart[existingIndex] = {
              ...existing,
              prod_qty: nextQty,
              prod_total: nextQty * parseFloat(row['Purchase Rate'] || 0),
            };
          } else {
            mergedCart.push({
              prod_id: row.matchedProduct.prod_id,
              prod_name: String(row['Product Name'] || "").trim() || row.matchedProduct.prod_name,
              prod_excel_name: String(row['Product Name'] || "").trim(),
              prod_matched_name: row.matchedProduct.prod_name,
              prod_code: row.matchedProduct.prod_code,
              prod_purchase_rate: row['Purchase Rate'],
              prod_brand: row.matchedProduct.prod_brand_name,
              prod_color: row.matchedProduct.prod_color_name,
              prod_floor: row.matchedFloor.prod_floor_id,
              prod_floor_name: row.matchedFloor.prod_floor_name,
              prod_rack: row.matchedRack.prod_rack_id,
              prod_rack_name: row.matchedRack.prod_rack_name,
              prod_qty: row['Quantity'],
              prod_total: row['Purchase Rate'] * row['Quantity'],
            });
          }
        }
      });

      cartSet(mergedCart);
      swal({ title: `${importedRowsCount} row(s) imported to cart`, icon: "success" });
      handleCloseExcelDialog();
    } catch (error) {
      swal({
        title: "Import failed",
        text: error.response?.data?.message || error.message,
        icon: "error",
      });
    } finally {
      setImportProcessing(false);
    }
  };

  // --- End of Excel Import Logic ---


  useEffect(() => {
    let subTotal = cart.reduce((prev, curr) => {
      return prev + parseFloat(curr.prod_total);
    }, 0);

    sub_total_set(subTotal);
  }, [cart, sub_total]);

  let employeeRef = useRef(null);
  let poRef = useRef(null);
  let dateRef = useRef(null);
  let customerRef = useRef(null);
  let contactPersonRef = useRef(null);
  let productRef = useRef(null);
  let rateRef = useRef(null);
  let brandRef = useRef(null);
  let countryRef = useRef(null);
  let floorRef = useRef(null);
  let rackRef = useRef(null);
  let qtyRef = useRef(null);
  let addToCartRef = useRef(null);
  let vatRef = useRef(null);
  let vatPercentRef = useRef(null);
  let aitRef = useRef(null);
  let aitPercentRef = useRef(null);
  let discountRef = useRef(null);
  let discountPercentRef = useRef(null);
  let paidRef = useRef(null);
  let dueRef = useRef(null);
  let saleRef = useRef(null);

  const fetchFloors = async () => {

    try {
      const response = await axios.post(
        `${API_URL}/api/get-floors`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );

      if (response.data && !response.data.error) {
        floorsSet(response.data.message);
      } else {
        console.error("API returned an error:", response.data.message);
        setLocations([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocations([]);
    }

  };

  const fetchRacks = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/api/get-racks`,
        {
          "select-type": "active"
        },
        { headers: { "auth-token": authInfo.token } }
      );

      if (response.data && !response.data.error) {
        racksSet(response.data.message);
      } else {
        console.error("API returned an error:", response.data.message);
        setLocations([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocations([]);
    }
  };

  const getCategories = async () => {
    const res = await axios.post(
      `${API_URL}/api/get-categories`,
      { "select-type": "active" },
      { headers: { "auth-token": authInfo.token } }
    );
    categoriesSet(res.data.message || []);
    return res.data.message || [];
  };

  const getBrands = async () => {
    const res = await axios.post(
      `${API_URL}/api/get-brands`,
      { "select-type": "active" },
      { headers: { "auth-token": authInfo.token } }
    );
    brandsSet(res.data.message || []);
    return res.data.message || [];
  };

  const getColors = async () => {
    const res = await axios.post(
      `${API_URL}/api/get-colors`,
      { "select-type": "active" },
      { headers: { "auth-token": authInfo.token } }
    );
    countrysSet(res.data.message || []);
    return res.data.message || [];
  };

  const getProdNames = async () => {
    const res = await axios.post(
      `${API_URL}/api/get-prod-names`,
      { "select-type": "active" },
      { headers: { "auth-token": authInfo.token } }
    );
    prodNamesSet(res.data.message || []);
    return res.data.message || [];
  };

  const getUnits = async () => {
    const res = await axios.post(
      `${API_URL}/api/get-units`,
      { "select-type": "active" },
      { headers: { "auth-token": authInfo.token } }
    );
    unitsSet(res.data.message || []);
    return res.data.message || [];
  };

  const getNextProductCode = async () => {
    const res = await axios.get(`${API_URL}/api/get-product-code`, {
      headers: { "auth-token": authInfo.token },
    });
    return res.data.message;
  };


  useEffect(() => {
    product_total_set(product_rate * product_qty);
  }, [product_rate, product_qty]);



  let getEmployees = async () => {
    await axios
      .post(
        `${API_URL}/api/get-employees`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        employeesSet(res.data.message);
      });
  };


  let getProducts = async () => {
    const res = await axios
      .post(
        `${API_URL}/api/get-individual-products`,
        {
          "select-type": "active",
          prodId: selectedProduct != null ? selectedProduct.prod_id : null,
        },
        { headers: { "auth-token": authInfo.token } }
      )
    const productList = res.data.message || [];
    productsSet(productList);
    localStorage.setItem("products", JSON.stringify(productList));
    return productList;
  };

  let productToCart = () => {
    const existingEditItem = editCartIndex !== null ? cart[editCartIndex] : null;

    if (selectedProduct == null) {
      swal({ title: "Select Product", icon: "warning" });
      return false;
    }
    if (selectedFloor === null || selectedRack === null) {
      swal({ title: "Floor and rack mandatory", icon: "warning" });
      return false;
    }
    if (parseFloat(product_qty) <= 0 || isNaN(parseFloat(product_qty))) {
      swal({ title: "Invalid Product Quantity", icon: "warning" });
      return false;
    }
    if (
      parseFloat(product_rate) <= 0 ||
      product_rate == "" ||
      isNaN(parseFloat(product_rate))
    ) {
      swal({ title: "Purchase Rate is Invalid.", icon: "warning" });
      return false;
    }

    const floorName =
      floors.find((f) => f.prod_floor_id === selectedFloor?.prod_floor_id)
        ?.prod_floor_name || "";
    const rackName =
      racks.find((r) => r.prod_rack_id === selectedRack?.prod_rack_id)
        ?.prod_rack_name || "";

    const item = {
      prod_id: selectedProduct.prod_id,
      prod_name: existingEditItem?.prod_excel_name || selectedProduct.prod_name,
      prod_excel_name: existingEditItem?.prod_excel_name || "",
      prod_matched_name: selectedProduct.prod_name,
      prod_code: selectedProduct.prod_code,
      prod_purchase_rate: product_rate,
      prod_brand: product_brand,
      prod_color: product_color,
      prod_floor: selectedFloor?.prod_floor_id,
      prod_floor_name: floorName,
      prod_rack: selectedRack?.prod_rack_id,
      prod_rack_name: rackName,
      prod_qty: product_qty,
      prod_total: product_total,
    };

    // Prevent duplicate product in cart (except the row being edited)
    const duplicateIndex = cart.findIndex(
      (curr, i) => curr.prod_id == selectedProduct.prod_id && i !== editCartIndex
    );
    if (duplicateIndex > -1) {
      swal({ title: "Product already exist in cart.", icon: "warning" });
      return false;
    }

    if (editCartIndex !== null) {
      let hardCopy = [...cart];
      hardCopy[editCartIndex] = item;
      cartSet(hardCopy);
      setEditCartIndex(null);
    } else {
      cartSet([...cart, item]);
    }

    product_rate_set(0);
    product_brand_set("");
    product_color_set("");
    product_qty_set("");
    product_total_set(0);
    selectedFloorSet(null);
    selectedRackSet(null);
    selectedProductSet(null);
    selectedQuantitySet(null);
    setResetKey((prev) => prev + 1);

    productRef.current.focus();
  };

  let cartFromRemove = (index) => {
    let hardCopy = [...cart];
    hardCopy.splice(index, 1);
    cartSet(hardCopy);
    if (inlineQtyEditIndex === index) {
      setInlineQtyEditIndex(null);
      setInlineQtyValue("");
    }

    let storageCopy = [...storageCart];
    storageCopy.splice(index, 1);
    storageCartSet(storageCopy);
  };

  const startInlineQtyEdit = (index) => {
    const item = cart[index];
    if (!item) return;
    setInlineQtyEditIndex(index);
    setInlineQtyValue(String(item.prod_qty ?? ""));
  };

  const cancelInlineQtyEdit = () => {
    setInlineQtyEditIndex(null);
    setInlineQtyValue("");
  };

  const saveInlineQtyEdit = (index) => {
    const qty = parseFloat(inlineQtyValue);
    if (isNaN(qty) || qty <= 0) {
      swal({ title: "Invalid quantity", icon: "warning" });
      return;
    }

    cartSet((prev) => {
      if (index < 0 || index >= prev.length) return prev;
      const next = [...prev];
      const item = { ...next[index] };
      const rate = parseFloat(item.prod_purchase_rate || 0);
      item.prod_qty = qty;
      item.prod_total = qty * rate;
      next[index] = item;
      return next;
    });

    if (editCartIndex === index) {
      product_qty_set(qty);
      product_total_set(qty * parseFloat(product_rate || 0));
    }

    setInlineQtyEditIndex(null);
    setInlineQtyValue("");
  };

  const cartItemEditStart = (index) => {
    const item = cart[index];
    if (!item) return;

    const prodObj = products.find((p) => p.prod_id == item.prod_id) || null;
    const floorObj =
      floors.find((f) => f.prod_floor_id == item.prod_floor) || null;
    const rackObj = racks.find((r) => r.prod_rack_id == item.prod_rack) || null;

    selectedProductSet(prodObj);
    selectedFloorSet(floorObj);
    selectedRackSet(rackObj);

    product_rate_set(item.prod_purchase_rate);
    product_brand_set(item.prod_brand);
    product_color_set(item.prod_color);
    product_qty_set(item.prod_qty);
    product_total_set(item.prod_total);

    setEditCartIndex(index);

    setTimeout(() => {
      if (rateRef.current) rateRef.current.focus();
    }, 0);
  };

  const cartItemEditCancel = () => {
    setEditCartIndex(null);

    product_rate_set(0);
    product_brand_set("");
    product_color_set("");
    product_qty_set("");
    product_total_set(0);
    selectedFloorSet(null);
    selectedRackSet(null);
    selectedProductSet(null);
    selectedQuantitySet(null);
    setResetKey((prev) => prev + 1);

    if (productRef.current) productRef.current.focus();
  };

  const clearImportedCartData = () => {
    cartSet([]);
    storageCartSet([]);
    note_set("");
    setEditCartIndex(null);
    setInlineQtyEditIndex(null);
    setInlineQtyValue("");
    product_rate_set(0);
    product_brand_set("");
    product_color_set("");
    product_qty_set("");
    product_total_set(0);
    selectedFloorSet(null);
    selectedRackSet(null);
    selectedProductSet(null);
    selectedQuantitySet(null);
    setResetKey((prev) => prev + 1);
    localStorage.removeItem('salesCart');
    localStorage.removeItem('salesStorageCart');
  };


  let stockSaveAction = async () => {
    if (selectedEmployee == null) {
      swal({ title: "Select an Employee", icon: "warning" });
      return false;
    }
    if (cart.length == 0) {
      swal({ title: "Cart is Empty.", icon: "warning" });
      return false;
    }

    const sqlEntryDate = toSqlDateTime(selectedDate);

    // This logic seems specific to sales, might need adjustment for stock entry
    let stockEntryPayload = {
      stock_emp_id: selectedEmployee != null ? selectedEmployee.employee_id : 0,
      created_isodt: sqlEntryDate,
      os_created_isodt: sqlEntryDate,
      sub_total,
      note,
      // ... other relevant fields for stock entry
    };

    saveActionSet(true);
    // IMPORTANT: The URL should be for saving stock, not sales.
    // Example: let url = `/api/save-opening-stock`;
    let url = `/api/save-opening-stock`; // Please verify this is the correct endpoint
    const requestBody = sanitizePayloadDates({
      cart,
      stockData: stockEntryPayload,
      created_isodt: sqlEntryDate,
      os_created_isodt: sqlEntryDate,
    });

    await axios.post(`${API_URL}${url}`, requestBody, { headers: { "auth-token": authInfo.token } })
      .then(async (res) => {
        if (!res.data.error) {
          const recentProductIds = [...new Set(cart.map((item) => Number(item.prod_id)).filter(Boolean))];
          localStorage.removeItem('salesCart');
          localStorage.removeItem('salesStorageCart');
          setRecentSavedProductIds(recentProductIds);
          setSavedSummaryPagination((prev) => ({ ...prev, page: 0 }));
          clearImportedCartData();
          await fetchSavedSummary(recentProductIds, 0, savedSummaryPagination.perPage, savedSummarySearchText);

          swal({
            title: `Stock entry successful!`,
            text: "Opening stock entry has been saved successfully.",
            icon: "success",
          });

        } else {
          swal({
            title: `Error: ${res.data.message}`,
            icon: "error",
          });
        }
      }).catch(err => {
        swal({
          title: `An error occurred while saving.`,
          icon: "error",
        });
      }).finally(() => {
        saveActionSet(false);
      });
  };

  useEffect(() => {
    if (editCartIndex !== null) return;
    selectedFloorSet(null);
    selectedRackSet(null);
    selectedQuantitySet(null);
  }, [selectedProduct, editCartIndex]);


  useEffect(() => {
    if (editCartIndex !== null) return;
    selectedRackSet(null)
    // fetchRacks is already called on mount, this ensures it re-evaluates when floor changes
  }, [selectedProduct, selectedFloor, editCartIndex]);

  const excelHeaders = ['Brand', 'Category', 'Product Name', 'Country Origin', 'Floor', 'Rack', 'Quantity', 'Purchase Rate'];
  const validExcelRows = excelData.filter((row) => row.isValid).length;
  const invalidExcelRows = excelData.length - validExcelRows;
  const focusAddToCartFromQuantity = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent?.stopImmediatePropagation?.();
    setTimeout(() => addToCartRef.current?.focus(), 0);
  };

  return (
    <div className={classes.root}>
      {/* Hidden file input for Excel upload */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx, .xls, .csv"
        onChange={handleExcelFileSelect}
      />

      {/* Excel Upload Dialog */}
      <Dialog
        open={isExcelUploadDialogOpen}
        onClose={handleCloseExcelDialog}
        fullWidth
        maxWidth="lg"
        classes={{ paper: classes.excelDialogPaper }}
      >
        <DialogTitle className={classes.excelDialogTitle}>
          Excel Import Review
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseExcelDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className={classes.excelDialogContent}>
          <div className={classes.excelSummaryBar}>
            <div className={classes.excelSummaryCard}>
              <span className={classes.excelSummaryLabel}>Total Rows</span>
              <strong>{excelData.length}</strong>
            </div>
            <div className={classes.excelSummaryCard}>
              <span className={classes.excelSummaryLabel}>Ready</span>
              <strong style={{ color: "#1f6f43" }}>{validExcelRows}</strong>
            </div>
            <div className={classes.excelSummaryCard}>
              <span className={classes.excelSummaryLabel}>Needs Review</span>
              <strong style={{ color: "#b64a3a" }}>{invalidExcelRows}</strong>
            </div>
          </div>
          <TableContainer component={Paper} className={classes.excelTableWrap}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {excelHeaders.map(header => (
                    <TableCell key={header} className={classes.excelTableHeadCell}>{header}</TableCell>
                  ))}
                  <TableCell className={classes.excelTableHeadCell}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {excelData.map((row, index) => {
                  const statusMeta = getImportStatusMeta(row);
                  return (
                  <TableRow
                    key={index}
                    className={row.isValid ? classes.excelValidRow : classes.excelInvalidRow}
                  >
                    {excelHeaders.map(header => (
                      <TableCell key={header} className={classes.excelTableCell}>{String(row[header])}</TableCell>
                    ))}
                    <TableCell className={classes.excelStatusCell}>
                      <div className={classes[`statusBadge${statusMeta.tone.charAt(0).toUpperCase() + statusMeta.tone.slice(1)}`]}>
                        {statusMeta.label}
                      </div>
                      <div className={classes.statusDetailText}>
                        {statusMeta.detail}
                      </div>
                    </TableCell>
                  </TableRow>
                )})}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions className={classes.excelDialogActions}>
          <Button onClick={handleCloseExcelDialog} color="secondary" disabled={isImportProcessing}>
            Cancel
          </Button>
          <Button onClick={handleConfirmExcelImport} color="primary" variant="contained" disabled={isImportProcessing}>
            {isImportProcessing ? "Processing..." : "Confirm & Add to Cart"}
          </Button>
        </DialogActions>
      </Dialog>


      <Paper
        className={classes.paper}
        style={{ marginTop: "-25px", marginBottom: "5px" }}
      >
        <h4
          style={{
            textAlign: "left",
            margin: 0,
            padding: 0,
            marginTop: "-10px",
            marginBottom: "2px",
          }}
        >
          Opening Stock Entry
        </h4>
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              size="small"
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  dateRef.current.focus();
                }
              }}
              value={selectedEmployee}
              openOnFocus={true}
              autoHighlight={true}
              style={{ width: "100%", height: "20px" }}
              options={employees}
              onChange={(e, employee) => {
                selectedEmployeeSet(employee);
              }}
              getOptionLabel={(option) => option.employee_name}
              renderInput={(params) => (
                <TextField inputRef={employeeRef} {...params} label="Entry by" variant="outlined" />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                style={{ width: "100%", marginTop: "" }}
                value={selectedDate}
                inputRef={dateRef}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    productRef.current.focus();
                  }
                }}
                onChange={handleDateChangeSet}
                name="entry_date"
                label="Entry Date & Time"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Paper className={classes.paper}>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "0px",
              }}
            >
              Product Information
            </h4>
            <Grid container spacing={2}>
              {/* Row 1: Product, Brand, Country */}
              <Grid item xs={12} sm={4} className={classes.plusLinkDiv}>
                <Link className={classes.plusLink} to="/administration/products-manage">
                  +
                </Link>
                <Autocomplete
                  openOnFocus
                  autoHighlight
                  size="small"
                  style={{ width: "100%" }}
                  options={products}
                  value={selectedProduct}
                  getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setTimeout(() => floorRef.current?.focus(), 0);
                    }
                  }}
                  onChange={(e, product) => {
                    if (!product) {
                      product_rate_set(0);
                      product_qty_set("");
                      product_brand_set("");
                      product_color_set("");
                      selectedProductSet(null);
                      return;
                    }
                    product_rate_set(product.prod_purchase_rate);
                    product_brand_set(product.prod_brand_name);
                    product_color_set(product.prod_color_name);
                    selectedIdSet(product.prod_id);
                    selectedProductSet(product);
                    floorRef.current.focus();
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputRef={productRef}
                      label="Choose a Product"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label="Brand"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={product_brand}
                  onChange={(e) => product_brand_set(e.target.value)}
                  inputRef={brandRef}
                  onKeyDown={(e) => e.key === "Enter" && countryRef.current.focus()}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label="Country"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={product_color}
                  onChange={(e) => product_color_set(e.target.value)}
                  inputRef={countryRef}
                  onKeyDown={(e) => e.key === "Enter" && floorRef.current.click()}
                  disabled
                />
              </Grid>

              {/* Row 2: Floor, Rack */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  autoHighlight
                  size="small"
                  openOnFocus
                  style={{ width: "100%" }}
                  options={floors || []}
                  value={selectedFloor}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setTimeout(() => rackRef.current?.focus(), 0);
                    }
                  }}
                  onChange={(e, floor) => {
                    selectedFloorSet(floor);
                    selectedRackSet(null);
                    product_qty_set("");
                  }}
                  getOptionLabel={(option) => option.prod_floor_name || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputRef={floorRef}
                      label="Choose a Floor"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  autoHighlight
                  size="small"
                  openOnFocus
                  style={{ width: "100%" }}
                  options={racks.filter(r => selectedFloor && r.prod_floor_id === selectedFloor.prod_floor_id) || []}
                  value={selectedRack}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setTimeout(() => rateRef.current?.focus(), 0);
                    }
                  }}
                  onChange={(e, rack) => {
                    selectedRackSet(rack);
                    rateRef.current.focus();
                  }}
                  getOptionLabel={(option) => option.prod_rack_name || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputRef={rackRef}
                      label="Choose a Rack"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              {/* Row 3: Purchase Rate, Quantity, Total */}
              <Grid item xs={12} sm={4}>
                <TextField
                  type="number"
                  label="Purchase Rate"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={product_rate}
                  onChange={(e) => product_rate_set(e.target.value)}
                  inputRef={rateRef}
                  onKeyDown={(e) => e.key === "Enter" && qtyRef.current.focus()}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  type="number"
                  label="Quantity"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={product_qty}
                  onChange={(e) => product_qty_set(e.target.value)}
                  inputRef={qtyRef}
                  onKeyDownCapture={focusAddToCartFromQuantity}
                  onKeyDown={focusAddToCartFromQuantity}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  label="Total"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={product_total}
                  onChange={(e) => product_total_set(e.target.value)}
                  disabled
                />
              </Grid>

              {/* Row 4: Buttons aligned right */}
              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="default"
                  size="small"
                  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                  startIcon={<PublishIcon />}
                  style={{ marginRight: '10px' }}
                >
                  Import from Excel
                </Button>
                <Button
                  ref={addToCartRef}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={productToCart}
                  startIcon={<SaveIcon />}
                >
                  {editCartIndex !== null ? "Update Cart" : "Add To Cart"}
                </Button>

                {editCartIndex !== null && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={cartItemEditCancel}
                    style={{ marginLeft: "10px" }}
                  >
                    Cancel
                  </Button>
                )}
              </Grid>
            </Grid>

          </Paper>

          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "5px" }}>
                <h4
                  style={{
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    marginTop: "-10px",
                    marginBottom: "3px",
                  }}
                >
                  Stock Entry Cart
                </h4>
                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                        <TableCell align="center" style={{ fontWeight: "bold", width: "50px" }}>SL</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>Product</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>Brand</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Floor</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Rack</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Purchase Rate</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>Total Amount</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cart.map((product, sl) => (
                        <TableRow key={parseFloat(sl) + 1}>
                          <TableCell>{parseFloat(sl) + 1}</TableCell>
                          <TableCell align="left">
                            {getCartProductLabel(product)}
                          </TableCell>
                          <TableCell align="left">{product.prod_brand}</TableCell>
                          <TableCell align="center">
                            {product.prod_floor_name}
                          </TableCell>
                          <TableCell align="center">
                            {product.prod_rack_name}
                          </TableCell>
                          <TableCell align="center">
                            {format(parseFloat(product.prod_purchase_rate).toFixed(2))}
                          </TableCell>
                          <TableCell align="center">
                            {inlineQtyEditIndex === sl ? (
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                                <TextField
                                  type="number"
                                  value={inlineQtyValue}
                                  onChange={(e) => setInlineQtyValue(e.target.value)}
                                  size="small"
                                  variant="outlined"
                                  style={{ width: "90px" }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") saveInlineQtyEdit(sl);
                                    if (e.key === "Escape") cancelInlineQtyEdit();
                                  }}
                                />
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="contained"
                                  onClick={() => saveInlineQtyEdit(sl)}
                                >
                                  Save
                                </Button>
                                <Button
                                  size="small"
                                  onClick={cancelInlineQtyEdit}
                                >
                                  Cancel
                                </Button>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                                <span>{product.prod_qty}</span>
                                <IconButton size="small" onClick={() => startInlineQtyEdit(sl)}>
                                  <EditIcon style={{ color: "#2e7d32", fontSize: "18px" }} />
                                </IconButton>
                              </div>
                            )}
                          </TableCell>
                          <TableCell align="right">
                            {format(parseFloat(product.prod_total).toFixed(2))}
                          </TableCell>
                          <TableCell align="right">
                            <IconButton onClick={() => cartItemEditStart(sl)}>
                              <EditIcon style={{ color: "#2e7d32" }} />
                            </IconButton>
                            <IconButton onClick={() => cartFromRemove(sl)}>
                              <DeleteIcon style={{ color: "red" }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}

                      {cart.length !== 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            align="right"
                            style={{ fontWeight: "bold" }}
                          >
                            Total :
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold" }}
                          >
                            {cart
                              .reduce((prev, curr) => {
                                return prev + parseFloat(curr.prod_qty);
                              }, 0)
                              .toFixed(2)}
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold" }}
                          >
                            {" "}
                            {format(parseFloat(sub_total).toFixed(2))}
                          </TableCell>
                          <TableCell colSpan={1}></TableCell>
                        </TableRow>
                      ) : (
                        <TableRow>
                          <TableCell colSpan={9} style={{ textAlign: 'center' }}>Cart is empty.</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    {cart.length !== 0 ? (
                      <TableRow>
                        <TableCell style={{ width: "325px", border: 'none' }}>
                          <TextareaAutosize
                            onChange={(e) => {
                              note_set(e.target.value);
                            }}
                            value={note}
                            name="note"
                            style={{
                              float: "left",
                              marginTop: "20px",
                              width: "325px",
                            }}
                            aria-label="Stock Entry Note..."
                            rowsMin={3}
                            placeholder="Stock Entry Note..."
                          />
                        </TableCell>

                        <TableCell colSpan={7} align="right" style={{ border: 'none' }}>
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={clearImportedCartData}
                            style={{ marginRight: "10px" }}
                          >
                            Clear Imported Data
                          </Button>
                          <LoadingButton
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={stockSaveAction}
                            startIcon={<SaveIcon />}
                            loading={saveAction}
                          >
                            Save Stock Entry
                          </LoadingButton>
                        </TableCell>
                      </TableRow>
                    ) : (
                      ""
                    )}
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "10px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap", marginBottom: "10px" }}>
                  <h4
                    style={{
                      textAlign: "left",
                      margin: 0,
                      padding: 0,
                      marginTop: "-10px",
                      marginBottom: "3px",
                    }}
                  >
                    Saved Stock Summary
                  </h4>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder="Search by code, product, brand, floor, rack..."
                      value={savedSummarySearchText}
                      onChange={(e) => {
                        setSavedSummarySearchText(e.target.value);
                        setSavedSummaryPagination((prev) => ({ ...prev, page: 0 }));
                      }}
                      style={{ minWidth: "320px", maxWidth: "420px" }}
                    />
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() =>
                        fetchSavedSummary(
                          recentSavedProductIds,
                          savedSummaryPagination.page,
                          savedSummaryPagination.perPage,
                          savedSummarySearchText
                        )
                      }
                      disabled={savedSummaryLoading}
                    >
                      Refresh
                    </Button>
                  </div>
                </div>

                <TableContainer>
                  <Table className={classes.table} size="small" aria-label="saved stock summary">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                        <TableCell align="center" style={{ fontWeight: "bold", width: "50px" }}>SL</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>Product</TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>Brand</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Floor</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Rack</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Purchase Rate</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Opening Qty</TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold" }}>Current Qty</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>Total Amount</TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {savedSummaryLoading ? (
                        <TableRow>
                          <TableCell colSpan={10} align="center">Loading saved stock summary...</TableCell>
                        </TableRow>
                      ) : savedSummaryRows.length > 0 ? (
                        savedSummaryRows.map((row, sl) => {
                          const isEditing = savedSummaryEditRowKey === row.__rowKey;
                          const isRecent = recentSavedProductIds.includes(Number(row?.prod_id));
                          const floorName = getSavedSummaryMetaValue(row, ["prod_floor_name", "floor_name", "FloorName"]);
                          const rackName = getSavedSummaryMetaValue(row, ["prod_rack_name", "rack_name", "RackName"]);
                          const brandName = getSavedSummaryMetaValue(row, ["prod_brand_name", "brand_name", "BrandName"]);
                          const openingQty = getSavedSummaryOpeningQty(row);
                          const currentQty = getSavedSummaryQty(row);
                          const rate = parseFloat(row?.prod_purchase_rate || 0);

                          return (
                            <React.Fragment key={row.__rowKey || `${row?.prod_id}-${sl}`}>
                              <TableRow style={isRecent ? { backgroundColor: "#eef9f0" } : undefined}>
                                <TableCell align="center">
                                  {(savedSummaryPagination.page * savedSummaryPagination.perPage) + sl + 1}
                                </TableCell>
                                <TableCell align="left">
                                  <div style={{ display: "flex", flexDirection: "column" }}>
                                    <strong>{`${row?.prod_code || ""} ${row?.prod_name || ""}`.trim() || "-"}</strong>
                                    {isRecent ? (
                                      <span style={{ fontSize: "12px", color: "#2e7d32" }}>
                                        Latest saved item
                                      </span>
                                    ) : null}
                                  </div>
                                </TableCell>
                                <TableCell align="left">{brandName}</TableCell>
                                <TableCell align="center">{floorName}</TableCell>
                                <TableCell align="center">{rackName}</TableCell>
                                <TableCell align="center">{format(rate.toFixed(2))}</TableCell>
                                <TableCell align="center">{format(openingQty.toFixed(2))}</TableCell>
                                <TableCell align="center">{format(currentQty.toFixed(2))}</TableCell>
                                <TableCell align="right">{format((currentQty * rate).toFixed(2))}</TableCell>
                                <TableCell align="right">
                                  <IconButton size="small" onClick={() => startSavedSummaryEdit(row)}>
                                    <EditIcon style={{ color: "#2e7d32" }} />
                                  </IconButton>
                                </TableCell>
                              </TableRow>

                              {isEditing ? (
                                <TableRow>
                                  <TableCell colSpan={10} style={{ backgroundColor: "#f8fbf8" }}>
                                    <Grid container spacing={2} alignItems="flex-end">
                                      <Grid item xs={12} sm={4}>
                                        <TextField
                                          size="small"
                                          variant="outlined"
                                          type="number"
                                          label="Purchase Rate"
                                          fullWidth
                                          value={savedSummaryEditPurchaseRate}
                                          onChange={(e) => setSavedSummaryEditPurchaseRate(e.target.value)}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4}>
                                        <TextField
                                          size="small"
                                          variant="outlined"
                                          type="number"
                                          label="Opening Quantity"
                                          fullWidth
                                          value={savedSummaryEditQuantity}
                                          onChange={(e) => setSavedSummaryEditQuantity(e.target.value)}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4}>
                                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                          <Button
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            onClick={saveSavedSummaryEdit}
                                            disabled={savedSummaryUpdating}
                                          >
                                            {savedSummaryUpdating ? "Updating..." : "Update"}
                                          </Button>
                                          <Button
                                            size="small"
                                            variant="contained"
                                            color="secondary"
                                            onClick={cancelSavedSummaryEdit}
                                            disabled={savedSummaryUpdating}
                                          >
                                            Cancel
                                          </Button>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            {savedSummarySearchText ? "No matching saved stock found." : "No saved stock summary available."}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  count={savedSummaryPagination.total}
                  rowsPerPage={savedSummaryPagination.perPage}
                  page={savedSummaryPagination.page}
                  onPageChange={(event, nextPage) => {
                    setSavedSummaryPagination((prev) => ({ ...prev, page: nextPage }));
                  }}
                  onChangePage={(event, nextPage) => {
                    setSavedSummaryPagination((prev) => ({ ...prev, page: nextPage }));
                  }}
                  onRowsPerPageChange={(event) => {
                    const nextPerPage = parseInt(event?.target?.value || 10, 10) || 10;
                    setSavedSummaryPagination({
                      page: 0,
                      perPage: nextPerPage,
                      total: savedSummaryPagination.total,
                    });
                  }}
                  onChangeRowsPerPage={(event) => {
                    const nextPerPage = parseInt(event?.target?.value || 10, 10) || 10;
                    setSavedSummaryPagination({
                      page: 0,
                      perPage: nextPerPage,
                      total: savedSummaryPagination.total,
                    });
                  }}
                />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: "100%",
    marginTop: "5px",
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  excelDialogPaper: {
    width: "min(1200px, calc(100vw - 24px))",
    maxHeight: "calc(100vh - 32px)",
    borderRadius: "16px",
    overflow: "hidden",
  },
  excelDialogTitle: {
    position: "relative",
    padding: theme.spacing(2, 3),
    fontWeight: 700,
    fontSize: "1.1rem",
    borderBottom: "1px solid #e7ecef",
    background: "linear-gradient(135deg, #f8fffb 0%, #eef8f2 100%)",
  },
  excelDialogContent: {
    padding: theme.spacing(2),
    backgroundColor: "#f7faf8",
  },
  excelDialogActions: {
    padding: theme.spacing(1.5, 2),
    borderTop: "1px solid #e7ecef",
    backgroundColor: "#ffffff",
    position: "sticky",
    bottom: 0,
    zIndex: 1,
  },
  excelSummaryBar: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  excelSummaryCard: {
    padding: theme.spacing(1.5, 2),
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid #e2ebe5",
    boxShadow: "0 8px 24px rgba(26, 71, 42, 0.06)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
  excelSummaryLabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    letterSpacing: "0.02em",
    color: "#5b6b61",
    textTransform: "uppercase",
  },
  excelTableWrap: {
    borderRadius: "14px",
    overflow: "auto",
    border: "1px solid #dde7e1",
    boxShadow: "0 10px 30px rgba(30, 54, 43, 0.08)",
    maxHeight: "calc(100vh - 250px)",
    [theme.breakpoints.down("xs")]: {
      maxHeight: "calc(100vh - 320px)",
    },
  },
  excelTableHeadCell: {
    backgroundColor: "#eff7f1",
    color: "#244233",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  excelTableCell: {
    verticalAlign: "top",
    minWidth: "82px",
  },
  excelStatusCell: {
    minWidth: "250px",
    verticalAlign: "top",
  },
  excelValidRow: {
    backgroundColor: "#ffffff",
  },
  excelInvalidRow: {
    backgroundColor: "#fff1f0",
  },
  statusBadgeSuccess: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#165b35",
    backgroundColor: "#e8f7ee",
  },
  statusBadgeWarning: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#8a5a00",
    backgroundColor: "#fff4d8",
  },
  statusBadgeError: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#a53a2c",
    backgroundColor: "#ffe2de",
  },
  statusDetailText: {
    marginTop: theme.spacing(0.75),
    fontSize: "0.8rem",
    lineHeight: 1.45,
    color: "#4e5b54",
    wordBreak: "break-word",
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, { currentRouteSet })(OpeningStockEntry);
